// Summon a named catalog token onto a picked target's cell (Gift of
// the Frog). Pure cell-center math. The mesh creation + table-add live
// in GameBoard's spawnTokenAtPoint primitive. Distinct from
// summon_token_at_locations, which expands a scope relative to the
// SOURCE's cell; here the destination is the single cell the picked
// allied minion occupies.
//
// ── Sorcery rule (Gift of the Frog) ──
// "Summon a Frog token to an allied minion." The token joins the picked
// minion at its location (units stack per Sorcery location rules), so
// the spawn point is the centre of the target's cell.

import { sampleCellGeometry } from '../../core/locations';

/**
 * World-space centre point { x, z } of the cell `unitCell`, or null
 * when the cell is out of grid bounds. Averages the four sampled
 * corners, matching the token-anchor math in spawnPlacement.
 */
export function cellCenterPoint(grid, unitCell) {
  if (!grid || !unitCell) return null;
  const geo = sampleCellGeometry(grid, unitCell.col, unitCell.row);
  if (!geo) return null;
  return {
    x: (geo.tl.x + geo.tr.x + geo.bl.x + geo.br.x) / 4,
    z: (geo.tl.z + geo.tr.z + geo.bl.z + geo.br.z) / 4,
  };
}
